import { GetterTree } from 'vuex'

import State, { IMultiplier } from './types'

import { RootState } from '../types'
import { MultiplierPricingType } from '../product/types'
export const getters: GetterTree<State, RootState> = {
  hasCustomerMultiplier(state): boolean {
    return state.customerMultipliers !== null
  },
  getMultiplierPrice: (state) => (pcnCatalogNumber, productHierarchy, originalPrice) => {
    const { customerMultipliers } = state
    if (originalPrice === null || isNaN(originalPrice)) {
      return originalPrice
    }
    if (customerMultipliers) {
      let multiplier: IMultiplier | undefined
      if (customerMultipliers.MaterialMultipliers[pcnCatalogNumber]) {
        multiplier = customerMultipliers.MaterialMultipliers[pcnCatalogNumber]
      } else if (customerMultipliers.ProductMultipliers[productHierarchy]) {
        multiplier = customerMultipliers.ProductMultipliers[productHierarchy]
      } else {
        multiplier = customerMultipliers.CustomerMultiplier
      }
      if (multiplier) {
        if (multiplier.PricingType === MultiplierPricingType.NetPrice) {
          return multiplier.Rate
        }
        return parseFloat(originalPrice.toString()) * multiplier.Rate / 100
      }
    }
    return parseFloat(originalPrice.toString())
  },
  hasSelectedCustomer(state): boolean {
    return state.customerMultipliers.CustomerMultiplier?.Number !== undefined
  },
}
